import ToolbarItem from "toolbar/ToolbarItem";

export default class ToolbarItemText extends ToolbarItem {

    constructor(text) {
        super();
        this.text = text;
    }

    getElement() {
        return (
            eotwJSXFactory('span', {className: "admin-toolbar__item admin-toolbar__item--text"}, [
                eotwJSXFactory('span', {className: "admin-toolbar__text"}, [
                    this.getText()
                ])
            ])
        );
    }

    getText() {
        return this.text;
    }
}
